export const connectorLocalStorageKey = "connectorId"
